import { AppUser, LiveLocation } from '@eventr/common'
import { LngLat } from 'maplibre-gl'

export default function getTeamMemberLocations(
    liveLocations: Map<string, LiveLocation>,
    selectedItineraryUsers: AppUser[],
    currentUser: AppUser
) {
    const teamMemberLocations = []

    liveLocations.forEach((value, key) => {
        const user = selectedItineraryUsers?.find((value) => {
            return value['globalID'] === key
        })

        if (
            !user ||
            !value.lngLat?.lat ||
            !value.lngLat?.lng ||
            value.staleTimestamp > Date.now() ||
            user.id === currentUser.id
        )
            return

        teamMemberLocations.push({
            lngLat: new LngLat(value.lngLat.lng, value.lngLat.lat),
            object: { ...user, timestamp: value.timestamp },
        })
    })

    return teamMemberLocations
}
